module.exports = __webpack_public_path__ + "img/announce-fill.bd550e00.svg";